import { RootState } from "../store";

export const selectDefectInsights = (state: RootState) => state.defectInsights;